export const SET_MYCORRECTIONREQ_LOADING = 'SET_MYCORRECTIONREQ_LOADING'
export const SET_MYCORRECTIONREQ = 'SET_MYCORRECTIONREQ'
export const ADD_CORRECTIONREQ = 'ADD_CORRECTIONREQ'
export const  DELETE_MY_CORRECTION_REQUEST = 'DELETE_MY_CORRECTION_REQUEST'